import { Section } from '../components/Section';
import {
  Container,
  Box,
  TabList,
  Tabs,
  Tab,
  Flex,
  Icon,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import type { IOrder } from '@/types';
import { IoIosArrowDropleft } from 'react-icons/io';
import { ShipmentCard } from '../components';
import { ROUTE_PATHS } from '@/constants';
import { NavLink } from 'react-router-dom';
import { useFetchDocs } from '@/hooks';
import { SectionLoader } from '@/components/shared';

export const UserShipments = (): JSX.Element => {
  const { t } = useTranslation();

  const { docs, isLoading } = useFetchDocs();

  let activeShipments: IOrder[] = [];
  let archivedShipments: IOrder[] = [];

  if (docs && docs.length > 0) {
    activeShipments = docs.filter(
      (shipment) =>
        shipment.status === 'SHIPMENT_REQUESTED' || shipment.status === 'SHIPMENT_SHIPPED'
    );

    archivedShipments = docs.filter(
      (shipment) =>
        shipment.status === 'SHIPMENT_CANCELED' || shipment.status === 'SHIPMENT_DELIVERED'
    );
  }

  return (
    <Box bg="brand.sand" py={8} w="full">
      <Container maxW="8xl" pt={{ base: 8, lg: 2 }} px={{ base: 4, md: 8 }}>
        <NavLink color="brand.red.light" to={ROUTE_PATHS.userDashboard}>
          <Icon
            as={IoIosArrowDropleft}
            color="brand.red.light"
            h={12}
            marginBottom={6}
            mx={0}
            w={12}
          />
        </NavLink>
        <Section id="quotes" title={t('ACCOUNT.SHIPMENTS.TITLE')}>
          <Tabs flexGrow={1} isLazy pt={6} variant="mbe">
            <TabList gap={{ base: 4, md: 2 }}>
              <Tab>{t('ACCOUNT.SHIPMENTS.ACTIVE')}</Tab>
              <Tab>{t('ACCOUNT.SHIPMENTS.ARCHIVE')}</Tab>
            </TabList>
            {isLoading ? (
              <SectionLoader />
            ) : (
              <TabPanels>
                <TabPanel pt={10} px={0}>
                  <Flex flexDirection="column" gap={10}>
                    {activeShipments.map((shipment) => (
                      <ShipmentCard key={shipment.id} shipment={shipment} />
                    ))}
                  </Flex>
                </TabPanel>
                <TabPanel pt={10} px={0}>
                  <Flex flexDirection="column" gap={10}>
                    {archivedShipments.map((shipment) => (
                      <ShipmentCard key={shipment.id} shipment={shipment} />
                    ))}
                  </Flex>
                </TabPanel>
              </TabPanels>
            )}
          </Tabs>
        </Section>
      </Container>
    </Box>
  );
};
